module.exports = __webpack_public_path__ + "static/media/slide_two.c3781ace.jpg";